import React, { createContext, useContext, useState, useEffect } from 'react';
import { setUnauthorizedCallback } from '../api/api';

const AuthContext = createContext();

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth debe ser usado dentro de AuthProvider');
  }
  return context;
};

export const AuthProvider = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(() => {
    return !!localStorage.getItem('token');
  });
  const [user, setUser] = useState(() => {
    try {
      const savedUser = localStorage.getItem('user');
      return savedUser ? JSON.parse(savedUser) : null;
    } catch {
      return null;
    }
  });
  const [token, setToken] = useState(() => {
    return localStorage.getItem('token');
  });

  const logout = () => {
    const themeMode = localStorage.getItem('themeMode');
    setUser(null);
    setToken(null);
    setIsAuthenticated(false);
    localStorage.clear();
    if (themeMode) {
      localStorage.setItem('themeMode', themeMode);
    }
  };

  useEffect(() => {
    setUnauthorizedCallback(() => {
      logout();
      window.location.href = '/login';
    });
  }, []);

  const login = (userData, authToken, credentials) => {
    setUser(userData);
    setToken(authToken);
    setIsAuthenticated(true);
    localStorage.setItem('token', authToken);
    localStorage.setItem('user', JSON.stringify(userData));
    if (credentials) {
      localStorage.setItem('credentials', JSON.stringify(credentials));
    }
  };

  const value = {
    isAuthenticated,
    user,
    token,
    login,
    logout
  };

  return (
    <AuthContext.Provider value={value}>
      {children}
    </AuthContext.Provider>
  );
};